import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import {
  formatText,
  formatVal,
  valToPercent,
} from '../../../../../helpers/value'
import { UNIT } from '../../constants'
import { CustomCell } from './CustomCell'
import { ShowOnChartBtn } from './ShowOnChartBtn'

export const RowGroup = ({
  rowId,
  rowGroupIndex,
  schema,
  selectRowGroup,
  selectCellData,
  activeRowGroupId,
  changeActiveRow,
  isDynamicReport,
}) => {
  const { formatCurrency, formatedUnit } = useFormatCurrency(
    SCREEN.INDUSTRY_ANALYSIS,
  )

  const locale = useSelector((state) => state.i18n.locale)
  const rowGroup = useSelector(selectRowGroup(rowId))

  const getFormatVal = (unitType, colId) => (val) => {
    switch (colId) {
      case 'ratioName':
        return (
          <>
            <div>
              <span className="fw600">{val}</span>
              &nbsp;(
              {unitType === UNIT.value.key ? (
                formatedUnit
              ) : (
                <Translate value={formatText(UNIT[unitType]?.label)} />
              )}
              )
            </div>
            {!isDynamicReport && (
              <ShowOnChartBtn
                activeRowGroupId={activeRowGroupId}
                rowId={rowId}
                changeActiveRow={changeActiveRow}
              />
            )}
          </>
        )

      case 'ratioIndicator':
        return isDynamicReport ? (
          formatText(val)
        ) : (
          <TextEllipsisStaticLine text={formatText(val)} isI18n={false} />
        )

      default:
        switch (unitType) {
          case UNIT['%'].key:
            return valToPercent(val, locale, 0, 0, 2, true)

          case UNIT.value.key:
            return formatCurrency({
              value: val,
              year: colId,
              exchangeRateType: 'lastDayRate',
            })

          default:
            return formatVal(val, locale)
        }
    }
  }

  const renderContent = (rowIndex, unitType) => {
    return schema.slice(rowIndex === 0 ? 0 : 1).map(({ colId }, colIndex) => {
      return (
        <CustomCell
          key={colIndex}
          rowSpan={colIndex === 0 && rowIndex === 0 ? rowGroup.length : 1}
          rowId={rowId}
          colIndex={colIndex}
          colId={colId}
          rowIndex={rowIndex}
          selectCellData={selectCellData}
          format={getFormatVal(unitType, colId)}
        />
      )
    })
  }

  const getBgColor = () => {
    if (isDynamicReport) {
      return rowGroupIndex % 2 === 0 ? '#F9F9F9' : '#FFFFFF'
    }

    return activeRowGroupId === rowId
      ? '#C8E3FF'
      : rowGroupIndex % 2 === 0
      ? '#F9F9F9'
      : '#FFFFFF'
  }

  return rowGroup.map(({ unitType }, rowIndex) => {
    return (
      <tr
        key={rowIndex}
        style={{
          borderBottom: rowIndex === rowGroup.length - 1 && '1px solid #D5D5D5',
          backgroundColor: getBgColor(),
        }}
      >
        {renderContent(rowIndex, unitType)}
      </tr>
    )
  })
}
